export const SET_KEYWORD = 'SET_KEYWORD';

export const setKeyword = (keyword) => {
  return {
    type: SET_KEYWORD,
    payload: keyword,
  };
};
